import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SettingService {
  baseUrl: string = environment.api_base_url;

  constructor(public http: HttpClient) {}

  getFinishingTypes() {
    return this.http.get(`${this.baseUrl}settings/get_finishing_types`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/settings-service/setting.service.ts